import React, { useCallback } from 'react'
import classNames from 'classnames'

import WrappedInput from '../WrappedInput'
import styles from './MultipleChoice.module.css'

const Option = function MultipleChoiceOption({ option, selected, onSelect }) {
  const { label, value } = option

  const handleSelect = useCallback(() => {
    onSelect(value)
  }, [onSelect, value])

  return (
    <div
      className={classNames(styles.option, selected && styles.selected)}
      onClick={handleSelect}
    >
      {label}
    </div>
  )
}

export default function MultipleChoice({
  input,
  meta,
  options,
  label,
  allowOther,
  otherPlaceholder,
}) {
  const { value, onChange } = input
  const { error, touched } = meta || {}

  const handleSelectOther = useCallback(() => {
    if (value && value.other) {
      return
    }

    onChange({ other: '' })
  }, [value, onChange])

  const handleChangeOther = useCallback(
    value => {
      onChange({ other: value })
    },
    [onChange]
  )

  const otherSelected = value && value.other !== undefined

  return (
    <div className={styles.wrapper}>
      <label style={styles.label}>{label}</label>
      <div className={styles.options}>
        {options.map(opt => (
          <Option
            option={opt}
            onSelect={onChange}
            selected={opt.value === value}
          />
        ))}
        {allowOther && (
          <Option
            option={{ label: 'Other' }}
            onSelect={handleSelectOther}
            selected={otherSelected}
          />
        )}
      </div>
      {allowOther && otherSelected ? (
        <WrappedInput
          className={styles.otherInput}
          type="text"
          placeholder={otherPlaceholder || 'Please describe...'}
          meta={meta}
          input={{
            value: value.other,
            onChange: handleChangeOther,
            onBlur: () => input.onBlur(),
          }}
        />
      ) : (
        error && touched && <p className={styles.error}>{error}</p>
      )}
    </div>
  )
}
